import { BaseCommand } from "./baseCommand";

export abstract class AbstractProductDataCommand extends BaseCommand {
  ids?: Array<number>;
}